module.exports = __webpack_public_path__ + "ptc_momoro_E1.db6b9f58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_E1.jpg
// module id = KQkj
// module chunks = 0